import { Pencil1Icon } from '@radix-ui/react-icons'
import React from 'react'

import {
  ISDescription,
  ISEditButton,
  ISInputDisplay,
  ISInputField,
  ISInputRow,
} from './StyledComponents'
import { handleEnterToBlur } from './utils'

interface ImagesInputRowProps {
  label: string
  value: string
  isEditing: boolean
  setIsEditing: (isEditing: boolean) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  displayOnly?: boolean
  ariaLabel?: string
}

export const ImagesInputRow = ({
  label,
  value,
  isEditing,
  setIsEditing,
  onChange,
  displayOnly = false,
  ariaLabel,
}: ImagesInputRowProps) => {
  return (
    <ISInputRow>
      <ISDescription>{label}</ISDescription>
      {isEditing && !displayOnly ? (
        <ISInputField
          value={value}
          onChange={onChange}
          onBlur={() => setIsEditing(false)}
          onKeyDown={handleEnterToBlur}
          autoFocus
        />
      ) : (
        <>
          <ISInputDisplay
            onClick={() => !displayOnly && setIsEditing(true)}
            style={{ cursor: displayOnly ? 'default' : 'pointer' }}>
            {value}
          </ISInputDisplay>
          {!displayOnly && (
            <ISEditButton
              onClick={() => setIsEditing(true)}
              aria-label={ariaLabel || `Edit ${label.toLowerCase()}`}>
              <Pencil1Icon />
            </ISEditButton>
          )}
        </>
      )}
    </ISInputRow>
  )
}
